import React from "react";

const NotificationsPage = () => {
  return (
    <div>
      <h3 className="fw-bold">Notifications</h3>
      <p className="text-muted">Your alerts, order updates, and messages.</p>

      <div className="alert alert-info">No new notifications.</div>
    </div>
  );
};

export default NotificationsPage;
